import { en } from './en';
import { fr } from './fr';

export const locales = {
  en,
  fr,
};
